import React, { useState, useEffect } from 'react';
import { ArrowLeft, ArrowRight, X, ChevronLeft, ChevronRight } from 'lucide-react';
import privateAPI from '../redux/privateApi';

const GetSelectedUserPhotos = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [slideshow, setSlideshow] = useState({
    isOpen: false,
    categoryIndex: 0,
    photoIndex: 0,
  });

  // Function to extract filename from URL
  const getFileName = (fileUrl) => {
    try {
      // Extract filename from the URL
      const urlParts = fileUrl.split('/');
      let fileName = urlParts[urlParts.length - 1];
      
      // Remove any query parameters
      fileName = fileName.split('?')[0];
      
      // Decode URL encoded characters
      fileName = decodeURIComponent(fileName);
      
      // Remove file extension
      fileName = fileName.replace(/\.[^/.]+$/, "");
      
      // Replace underscores and hyphens with spaces
      fileName = fileName.replace(/[_-]/g, " ");
      
      // Capitalize first letter of each word
      fileName = fileName.split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
      
      return fileName;
    } catch (err) {
      return "Photo";
    }
  };

  // Handle back button click
  const handleBackClick = () => {
    window.history.back();
  };

  // Open slideshow modal
  const openSlideshow = (categoryIndex, photoIndex) => {
    setSlideshow({
      isOpen: true,
      categoryIndex,
      photoIndex,
    });
    // Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';
  };

  // Close slideshow modal
  const closeSlideshow = () => {
    setSlideshow({
      ...slideshow,
      isOpen: false,
    });
    // Re-enable scrolling
    document.body.style.overflow = 'auto';
  };

  // Navigate to next photo
  const nextPhoto = () => {
    const category = categories[slideshow.categoryIndex];
    const totalPhotos = category.selected_files.length;
    
    setSlideshow({
      ...slideshow,
      photoIndex: (slideshow.photoIndex + 1) % totalPhotos,
    });
  };

  // Navigate to previous photo
  const prevPhoto = () => {
    const category = categories[slideshow.categoryIndex];
    const totalPhotos = category.selected_files.length;
    
    setSlideshow({
      ...slideshow,
      photoIndex: (slideshow.photoIndex - 1 + totalPhotos) % totalPhotos,
    });
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!slideshow.isOpen) return;
      
      switch (e.key) {
        case 'ArrowRight':
          nextPhoto();
          break;
        case 'ArrowLeft':
          prevPhoto();
          break;
        case 'Escape':
          closeSlideshow();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [slideshow]);

  // useEffect(() => {
  //   const fetchPhotos = async () => {
  //     try {
  //       // Get token from localStorage
  //       const token = localStorage.getItem('access_token');
        
  //       if (!token) {
  //         throw new Error('Authentication token not found in local storage');
  //       }

  //       const response = await fetch(
  //         'https://backend.newbrindha.com/photostudio/user/private/get_select_files',
  //         {
  //           headers: {
  //             'Authorization': `Bearer ${token}`,
  //             'Content-Type': 'application/json'
  //           }
  //         }
  //       );

  //       // if (!response.ok) {
  //       //   throw new Error(`Error: ${response.status} ${response.statusText}`);
  //       // }

  //       const data = await response.json();
        
  //       // Filter to only include categories with selected files
  //       const filteredCategories = data.files_data
  //         .map(category => ({
  //           ...category,
  //           selected_files: category.selected_files.filter(file => file.selected_status.selected)
  //         }))
  //         .filter(category => category.selected_files.length > 0);
        
  //       setCategories(filteredCategories);
  //       setLoading(false);
  //     } catch (err) {
  //       console.error('Failed to fetch photos:', err);
  //       //setError(err.message);
  //       setLoading(false);
  //     }
  //   };

  //   fetchPhotos();
  // }, []);

 useEffect(() => {
  const fetchPhotos = async () => {
    try {
      const userId = localStorage.getItem('user_id');
      if (!userId) {
        throw new Error('User ID not found in localStorage');
      }

      const response = await fetch(
        `https://backend.newbrindha.com/photostudio/user/private/get_select_files?user_id=${userId}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      
      const filteredCategories = data.files_data
        .map(category => ({
          ...category,
          selected_files: category.selected_files.filter(
            file => file.selected_status?.selected
          )
        }))
        .filter(category => category.selected_files.length > 0);

      setCategories(filteredCategories);
      setLoading(false);
    } catch (err) {
      //console.error('Failed to fetch photos:', err);
      setLoading(false);
    }
  };

  fetchPhotos();
}, []);


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Loading your selected photos...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="max-w-md p-6 bg-white rounded-lg shadow-md">
          <div className="flex items-center gap-3 text-red-500">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <h3 className="text-xl font-semibold">Error loading photos</h3>
          </div>
          <p className="mt-3 text-gray-600">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  // Render slideshow modal
  const renderSlideshow = () => {
    if (!slideshow.isOpen || categories.length === 0) return null;
    
    const category = categories[slideshow.categoryIndex];
    const photo = category.selected_files[slideshow.photoIndex];
    const totalPhotos = category.selected_files.length;
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex flex-col justify-center items-center">
        {/* Close button */}
        <button 
          onClick={closeSlideshow}
          className="absolute top-4 right-4 text-white hover:text-gray-300 p-2"
          aria-label="Close slideshow"
        >
          <X size={24} />
        </button>
        
        {/* Navigation controls */}
        <div className="absolute top-1/2 left-4 transform -translate-y-1/2">
          <button 
            onClick={prevPhoto}
            className="bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full"
            aria-label="Previous photo"
          >
            <ChevronLeft size={24} />
          </button>
        </div>
        
        <div className="absolute top-1/2 right-4 transform -translate-y-1/2">
          <button 
            onClick={nextPhoto}
            className="bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full"
            aria-label="Next photo"
          >
            <ChevronRight size={24} />
          </button>
        </div>
        
        {/* Image container */}
        <div className="w-full max-w-4xl h-3/4 flex justify-center items-center px-12">
          <img
            src={photo.file_url}
            alt={getFileName(photo.file_url)}
            className="max-h-full max-w-full object-contain"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://via.placeholder.com/800x600?text=Photo+Not+Available';
            }}
          />
        </div>
        
        {/* Caption and counter */}
        <div className="bg-black bg-opacity-70 text-white p-4 w-full max-w-4xl">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-medium">{getFileName(photo.file_url)}</h3>
            <p className="text-sm text-gray-300">{slideshow.photoIndex + 1} of {totalPhotos}</p>
          </div>
          <p className="text-sm text-gray-300 mt-1">Category: {category.category}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            User Selected Photos
          </h1>
          <p className="mt-3 text-gray-500">
            {categories.length > 0 
              ? "Here are all the photos the user has selected. Click on any photo to view slideshow."
              : "User selected photos will appear here"}
          </p>
          <button 
            onClick={handleBackClick}
            className="flex items-center gap-2 mt-4 mx-auto px-4 py-2 bg-white text-gray-700 rounded-md hover:bg-gray-100 transition-colors border border-gray-300 shadow-sm"
          >
            <ArrowLeft size={16} />
            <span>Back</span>
          </button>
        </div>
        
        {categories.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm p-8 text-center max-w-2xl mx-auto">
            <div className="mx-auto h-24 w-24 text-gray-300 mb-4">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900">No photos selected yet</h3>
            <p className="mt-2 text-gray-500">You haven't selected any photos to display here.</p>
          </div>
        ) : (
          <div className="space-y-8">
            {categories.map((category, categoryIndex) => (
              <div key={category.private_files_id} className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="p-6">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="flex-shrink-0 bg-blue-100 p-3 rounded-lg">
                      <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                      </svg>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800">{category.category}</h2>
                  </div>
                  
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    {category.selected_files.map((file, photoIndex) => (
                      <div 
                        key={file.file_id} 
                        className="group relative rounded-md overflow-hidden border border-gray-200 hover:border-blue-300 transition-all duration-200 cursor-pointer"
                        onClick={() => openSlideshow(categoryIndex, photoIndex)}
                      >
                        <div className="aspect-w-3 aspect-h-2 bg-gray-100">
                          <img
                            src={file.file_url}
                            alt={`Selected from ${category.category}`}
                            className="w-full h-48 object-cover group-hover:opacity-95 transition-opacity duration-200"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://via.placeholder.com/400x300?text=Photo+Not+Available';
                            }}
                          />
                          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                            <div className="bg-white bg-opacity-80 rounded-full p-2">
                              <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="p-3 bg-gray-50">
                          <h3 className="text-sm font-medium text-gray-800 mb-1 truncate" title={getFileName(file.file_url)}>
                            {getFileName(file.file_url)}
                          </h3>
                          <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800">
                            Selected
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* Render slideshow modal */}
      {renderSlideshow()}
    </div>
  );
};

export default GetSelectedUserPhotos;